import { registerHandler } from '../paymentHandlerRegistry';

/**
 * Cielo TDC credit card handler.
 * Handle credit card payments through the Cielo TDC form (3DS/SOP flows).
 * Delegates form submission to the CieloTDCContext via engineHooks.
 */
const cieloCreditCardPaymentHandler = {
  canHandle: ({ selectedPaymentMethod, env, cardCheckoutMode }) => {
    const cieloHasActiveFlow = env?.cielo?.enableThreeDS || env?.cielo?.enableSilentOrderPost;
    return (
      cardCheckoutMode !== 'basis_theory' &&
      selectedPaymentMethod?.engine === 'cielo' &&
      Boolean(cieloHasActiveFlow)
    );
  },

  execute: async ({ engineHooks }) => {
    await engineHooks.cieloTDC.executePayment();
  },
};

registerHandler('credit_card', cieloCreditCardPaymentHandler);
